/**
 * Olfativa Suggestion Cards Enhanced
 * Moléculas aromáticas + Grid horizontal
 * Auto-inyectable en Shopify
 */

(function () {
    // Inyectar estilos
    const styleSheet = document.createElement('style');
    styleSheet.textContent = `
        .olfativa-suggestion-options {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(80px, 1fr));
            gap: 12px;
            padding: 14px;
            background: #fffaf1;
            border-radius: 12px;
            margin-top: 10px;
            border: 1px solid rgba(201, 169, 110, 0.2);
            animation: slideDown 0.2s ease-out;
        }

        @keyframes slideDown {
            from {
                opacity: 0;
                transform: translateY(-8px);
            }
            to {
                opacity: 1;
                transform: translateY(0);
            }
        }

        .olfativa-option-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 8px;
            padding: 10px;
            border: 1px solid rgba(201, 169, 110, 0.28);
            border-radius: 10px;
            background: #ffffff;
            cursor: pointer;
            transition: all 0.2s ease;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
        }

        .olfativa-option-item:hover {
            border-color: rgba(201, 169, 110, 0.5);
            background: rgba(201, 169, 110, 0.05);
            transform: translateY(-2px);
        }

        .olfativa-option-item.selected {
            background: rgba(201, 169, 110, 0.25);
            border-color: rgba(201, 169, 110, 0.5);
            font-weight: 500;
        }

        .olfativa-option-canvas {
            border-radius: 50%;
            width: 56px;
            height: 56px;
        }

        .olfativa-option-label {
            font-size: 11px;
            font-weight: 500;
            text-align: center;
            color: #2a1f14;
            line-height: 1.2;
            letter-spacing: 0.3px;
        }

        .olfativa-option-label.selected::before {
            content: '✓ ';
            color: #c9a96e;
        }

        .olfativa-options-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 8px;
            padding: 0 2px;
        }

        .olfativa-options-close {
            background: none;
            border: none;
            font-size: 20px;
            color: #8c7a62;
            cursor: pointer;
            padding: 0;
            width: 24px;
            height: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: color 0.2s;
        }

        .olfativa-options-close:hover {
            color: #c9a96e;
        }
    `;
    document.head.appendChild(styleSheet);

    // Definición de familias aromáticas
    const OLFATIVA_FAMILIES = {
        amaderados: {
            label: 'Amaderados',
            color: '#C9A96E',
            nodes: [
                { x: 16, y: 52 }, { x: 30, y: 34 }, { x: 50, y: 28 },
                { x: 66, y: 38 }, { x: 70, y: 58 }, { x: 52, y: 20 }, { x: 34, y: 44 }
            ],
            bonds: [[0, 1], [1, 2], [2, 3], [3, 4], [4, 1], [5, 2], [6, 1], [6, 3]]
        },
        citricos: {
            label: 'Cítricos',
            color: '#E8C868',
            nodes: [
                { x: 36, y: 12 }, { x: 56, y: 12 }, { x: 64, y: 32 },
                { x: 56, y: 52 }, { x: 36, y: 52 }, { x: 28, y: 32 }, { x: 36, y: 32 }
            ],
            bonds: [[0, 1], [1, 2], [2, 3], [3, 4], [4, 5], [5, 0], [0, 6], [2, 6], [4, 6]]
        },
        florales: {
            label: 'Florales',
            color: '#E8A0B8',
            nodes: [
                { x: 36, y: 10 }, { x: 58, y: 22 }, { x: 62, y: 46 },
                { x: 46, y: 60 }, { x: 24, y: 48 }, { x: 20, y: 24 }, { x: 36, y: 36 }, { x: 56, y: 22 }
            ],
            bonds: [[0, 1], [1, 2], [2, 3], [3, 4], [4, 5], [5, 0], [6, 0], [6, 2], [6, 4], [7, 1]]
        },
        herbal: {
            label: 'Herbal',
            color: '#88C888',
            nodes: [
                { x: 36, y: 10 }, { x: 60, y: 24 }, { x: 62, y: 50 },
                { x: 40, y: 62 }, { x: 16, y: 48 }, { x: 14, y: 22 }, { x: 36, y: 36 }
            ],
            bonds: [[0, 1], [1, 2], [2, 3], [3, 4], [4, 5], [5, 0], [6, 0], [6, 2], [6, 4]]
        },
        frutal: {
            label: 'Frutal',
            color: '#E89860',
            nodes: [
                { x: 20, y: 44 }, { x: 36, y: 22 }, { x: 56, y: 20 },
                { x: 68, y: 38 }, { x: 60, y: 58 }, { x: 36, y: 58 }, { x: 44, y: 40 }
            ],
            bonds: [[0, 1], [1, 2], [2, 3], [3, 4], [4, 5], [5, 0], [6, 1], [6, 3], [6, 5]]
        },
        verdes: {
            label: 'Verdes',
            color: '#A8D870',
            nodes: [
                { x: 36, y: 8 }, { x: 58, y: 20 }, { x: 64, y: 44 },
                { x: 48, y: 62 }, { x: 22, y: 56 }, { x: 14, y: 30 }, { x: 36, y: 36 }
            ],
            bonds: [[0, 1], [1, 2], [2, 3], [3, 4], [4, 5], [5, 0], [6, 0], [6, 2], [6, 4]]
        },
        ocasion: {
            label: 'Ocasión',
            color: '#D4A0C0',
            nodes: [
                { x: 36, y: 10 }, { x: 60, y: 22 }, { x: 66, y: 48 },
                { x: 50, y: 64 }, { x: 24, y: 60 }, { x: 14, y: 36 }, { x: 20, y: 18 }, { x: 36, y: 40 }
            ],
            bonds: [[0, 1], [1, 2], [2, 3], [3, 4], [4, 5], [5, 6], [6, 0], [7, 1], [7, 3], [7, 5]]
        }
    };

    // Renderizador de moléculas
    function createMoleculeCanvas(familyKey, canvasId) {
        const canvas = document.createElement('canvas');
        canvas.id = canvasId;
        canvas.width = 56;
        canvas.height = 56;
        canvas.className = 'olfativa-option-canvas';

        const ctx = canvas.getContext('2d');
        const fam = OLFATIVA_FAMILIES[familyKey];
        if (!fam) return canvas;

        const W = canvas.width;
        const H = canvas.height;
        const scaleX = W / 100;
        const scaleY = H / 72;

        let frame = 0;
        const animateFrame = function () {
            const t = (frame * 0.016) % (Math.PI * 2);
            ctx.clearRect(0, 0, W, H);

            const nodes = fam.nodes.map(function (n, i) {
                let x = n.x * scaleX;
                let y = n.y * scaleY;
                const cx = W / 2;
                const cy = H / 2;
                const dx = x - cx;
                const dy = y - cy;

                // Waiting state: suave espiral
                const sp = t * 1.4 + (i / fam.nodes.length) * Math.PI * 2;
                const r = Math.sqrt(dx * dx + dy * dy);
                const baseAngle = Math.atan2(dy, dx);
                const newAngle = baseAngle + sp * 0.4;
                const pulse = 1 + Math.sin(t * 2.5 + i) * 0.14;

                x = cx + Math.cos(newAngle) * r * pulse;
                y = cy + Math.sin(newAngle) * r * pulse;

                return { x: x, y: y };
            });

            // Glow center
            const glowR = W * 0.32;
            const gr = ctx.createRadialGradient(W / 2, H / 2, 0, W / 2, H / 2, glowR);
            gr.addColorStop(0, fam.color + '19');
            gr.addColorStop(1, 'transparent');
            ctx.fillStyle = gr;
            ctx.beginPath();
            ctx.arc(W / 2, H / 2, glowR * 1.2, 0, Math.PI * 2);
            ctx.fill();

            // Bonds
            ctx.globalAlpha = 0.5 + Math.sin(t * 1.2) * 0.15;
            ctx.strokeStyle = fam.color;
            ctx.lineWidth = 0.9;
            fam.bonds.forEach(function ([a, b]) {
                if (a >= nodes.length || b >= nodes.length) return;
                ctx.beginPath();
                ctx.moveTo(nodes[a].x, nodes[a].y);
                ctx.lineTo(nodes[b].x, nodes[b].y);
                ctx.stroke();
            });

            // Nodes
            nodes.forEach(function (n, i) {
                const nodeSize = 2.2 + Math.sin(t * 2.5 + i) * 0.8;

                ctx.globalAlpha = 0.2;
                const ng = ctx.createRadialGradient(n.x, n.y, 0, n.x, n.y, nodeSize * 2.5);
                ng.addColorStop(0, fam.color);
                ng.addColorStop(1, 'transparent');
                ctx.fillStyle = ng;
                ctx.beginPath();
                ctx.arc(n.x, n.y, nodeSize * 2.5, 0, Math.PI * 2);
                ctx.fill();

                ctx.globalAlpha = 0.7 + Math.sin(t * 2.5 + i * 0.7) * 0.25;
                ctx.fillStyle = fam.color;
                ctx.beginPath();
                ctx.arc(n.x, n.y, nodeSize, 0, Math.PI * 2);
                ctx.fill();
            });

            ctx.globalAlpha = 1;
            frame++;
            requestAnimationFrame(animateFrame);
        };

        animateFrame();
        return canvas;
    }

    // Función para cerrar opciones y reiniciar tarjetas
    window.olfativaCloseOptions = function () {
        if (window.olfativaCurrentCloseCallback) {
            window.olfativaCurrentCloseCallback();
            window.olfativaCurrentCloseCallback = null;
        }
    };

    // Publicar función global para renderizar opciones
    window.olfativaRenderOptions = function (containerElement, dimension, onSelect, onClose) {
        if (!containerElement) return;

        // Guardar callback de cierre
        window.olfativaCurrentCloseCallback = onClose;

        const optionsContainer = document.createElement('div');
        optionsContainer.className = 'olfativa-suggestion-options';

        // Header con botón cerrar
        const header = document.createElement('div');
        header.className = 'olfativa-options-header';

        const label = document.createElement('div');
        label.style.fontSize = '12px';
        label.style.fontWeight = '500';
        label.style.color = '#8c7a62';
        label.textContent = dimension === 'aroma' ? 'Familias aromáticas' : dimension === 'lugar' ? 'Espacios' : 'Objetivos';

        const closeBtn = document.createElement('button');
        closeBtn.className = 'olfativa-options-close';
        closeBtn.textContent = '×';
        closeBtn.type = 'button';
        closeBtn.onclick = function (e) {
            e.stopPropagation();
            window.olfativaCloseOptions();
        };

        header.appendChild(label);
        header.appendChild(closeBtn);
        optionsContainer.appendChild(header);

        let families = [];
        if (dimension === 'aroma') {
            families = Object.keys(OLFATIVA_FAMILIES);
        } else if (dimension === 'lugar') {
            families = ['casa', 'negocio', 'apartamento', 'oficina', 'auto'];
        } else if (dimension === 'objetivo') {
            families = ['elegante', 'relajante', 'energizante', 'profesional', 'diario', 'ocasiones'];
        }

        families.forEach(function (familyKey) {
            const isAroma = dimension === 'aroma';
            const fam = OLFATIVA_FAMILIES[familyKey];

            const optionItem = document.createElement('div');
            optionItem.className = 'olfativa-option-item';
            optionItem.style.cursor = 'pointer';

            if (isAroma && fam) {
                const canvasId = 'mol-' + familyKey + '-' + Date.now();
                const canvas = createMoleculeCanvas(familyKey, canvasId);
                optionItem.appendChild(canvas);
            }

            const label = document.createElement('div');
            label.className = 'olfativa-option-label';
            label.textContent = isAroma && fam ? fam.label : familyKey.charAt(0).toUpperCase() + familyKey.slice(1);

            optionItem.appendChild(label);

            optionItem.addEventListener('click', function (e) {
                e.stopPropagation();
                label.classList.add('selected');
                optionItem.classList.add('selected');

                setTimeout(function () {
                    if (onSelect) {
                        onSelect(familyKey);
                    }
                }, 300);
            });

            optionsContainer.appendChild(optionItem);
        });

        containerElement.innerHTML = '';
        containerElement.appendChild(optionsContainer);

        // Cerrar si clickea afuera
        setTimeout(function () {
            function closeOnClickOutside(e) {
                const options = document.querySelector('.olfativa-suggestion-options');
                const suggestions = document.getElementById('olfativa-chat-suggestions');

                if (options && suggestions && !options.contains(e.target) && !suggestions.contains(e.target)) {
                    window.olfativaCloseOptions();
                    document.removeEventListener('click', closeOnClickOutside);
                }
            }

            document.addEventListener('click', closeOnClickOutside);
        }, 100);
    };
})();